import { create } from 'zustand';

export type ErrorType = 'error' | 'warning' | 'info';

export interface ErrorAction {
  label: string;
  onClick: () => void;
}

export interface AppError {
  id: string;
  type: ErrorType;
  title: string;
  message: string;
  action?: ErrorAction;
}

interface ErrorStore {
  errors: AppError[];
  setError: (error: AppError) => void;
  clearError: (id: string) => void;
  clearAllErrors: () => void;
}

export const useErrorStore = create<ErrorStore>((set) => ({
  errors: [],
  setError: (error) => set((state) => ({
    errors: [...state.errors.filter(err => err.id !== error.id), error]
  })),
  clearError: (id) => set((state) => ({
    errors: state.errors.filter(error => error.id !== id)
  })),
  clearAllErrors: () => set({ errors: [] })
})); 